import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { ProviderStatusDTO } from "../../../../common/types/ProviderStatusDTO";
import { baseQuery } from "../../client/DefaultClient";

export type { ProviderStatusDTO as ProviderStatus } from "../../../../common/types/ProviderStatusDTO";

export const statusService = createApi({
  reducerPath: "statusService",
  baseQuery: fetchBaseQuery(baseQuery),
  endpoints: (builder) => ({
    getProviderStatuses: builder.query<ProviderStatusDTO[], void>({
      query: () => "api/status/providers",
    }),
  }),
});

export const { useGetProviderStatusesQuery } = statusService;
